import { CartState } from "./cart-types";

export const cart_init_state: CartState = {
  data: null,
};
